import { ReactNode } from 'react';

import Button from '~/components/scales/Button/Button';
import Icon from '~/components/scales/Icon/Icon';
import IconButton from '~/components/scales/IconButton/IconButton';
import TertiaryButton from '~/components/scales/TertiaryButton/TertiaryButton';
import Tooltip from '~/components/scales/Tooltip/Tooltip';

type Props = {
  header: string;
  description: ReactNode;
  buttonLabel: string;
  image: ReactNode;
  onCTA: () => void;
  onDismiss: () => void;
  onRemindMeLater: () => void;
};

export default function MarketingBanner(props: Props) {
  return (
    <div className="flex w-full min-w-min justify-between gap-4 rounded-xl bg-marketing-banner-default-bg p-4">
      <div className="flex min-w-min flex-grow basis-0 flex-col justify-between gap-5">
        <div className="flex flex-col gap-2">
          <div className="text-type-primary type-heading2">{props.header}</div>
          <div className="flex min-w-0 flex-wrap text-type-primary type-body1">
            {props.description}
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button label={props.buttonLabel} onClick={props.onCTA} type="secondary" />
          <TertiaryButton label="Remind me later" onClick={props.onRemindMeLater} />
        </div>
      </div>
      <div className="flex max-h-40 max-w-sm flex-grow basis-0 items-center self-center">
        {props.image}
      </div>
      <Tooltip content={`Don't show me this again`} placement="bottom">
        <IconButton
          aria-label="Close banner"
          icon={<Icon name="close" />}
          onClick={props.onDismiss}
          type="secondary"
        />
      </Tooltip>
    </div>
  );
}
